import {DefectClassification, DefectType} from "../../models/defectType";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsCommands} from "../../shared/dto/aps.commands";
import * as angular from 'angular';
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";
import * as _ from "lodash";

export interface DefectTypesAndClassifications {
  classifications: DefectClassification[];
  types: DefectType[];
}

export interface DefectTypeService {
  getDefectTypesAndClassifications(): angular.IPromise<DefectTypesAndClassifications>;
  getDefectTypesAndClassificationsNoExclusion(): angular.IPromise<DefectTypesAndClassifications>;
  getDefectTypeDetails(defectTypeId: string): angular.IPromise<apsViewModels.DefectTypeDetails>;
  submitDefectType(defectTypeCommand: apsCommands.EditDefectType): angular.IPromise<any>;
  addDefectType(defectTypeCommand: apsCommands.AddDefectType): angular.IPromise<any>;
  getDefectTypeWareClasses(): angular.IPromise<apsViewModels.WareClassSelection[]>;
  getDefectTypesAll(): angular.IPromise<apsViewModels.LookupItem[]>;
}

export default angular.module('aps.services.defectTypes', [HttpServiceName])
  .service('defectTypeService', function(httpService: HttpService): DefectTypeService {
    function getDefectTypesAndClassifications() {
      return httpService.get(Endpoints.DEFECT_TYPES)
        .then(data => {
          let classifications = [];
          let types = [];
          _.forEach(data, (viewModel) => {
            types.push(new DefectType(viewModel, classifications));
          });
          return {
            classifications: classifications,
            types: types
          };
        });
    }

    function getDefectTypesAndClassificationsNoExclusion() {
      return httpService.get(Endpoints.DEFECT_TYPES_NO_EXCLUSION)
        .then(data => {
          let classifications = [];
          let types = [];
          _.forEach(data, (viewModel) => {
            types.push(new DefectType(viewModel, classifications));
          });
          return {
            classifications: classifications,
            types: types
          };
        });
    }
    
    function getDefectTypesAll() {
      return httpService.get<apsViewModels.LookupItem[]>(Endpoints.DEFECT_TYPES_ALL);
    }

    function getDefectTypeDetails(defectTypeId) {
      let url = Endpoints.DEFECT_TYPE_DETAILS.replace('{0}', defectTypeId);
      return httpService.get<apsViewModels.DefectTypeDetails>(url);
    }

    function submitDefectType(defectTypeCommand) {
      let url = Endpoints.DEFECT_TYPE_DETAILS.replace('{0}', defectTypeCommand.id);
      return httpService.post(url, defectTypeCommand);
    }

    function addDefectType(defectTypeCommand) {
      let url = Endpoints.DEFECT_TYPE_ADD;
      return httpService.post(url, defectTypeCommand);
    }

    function getDefectTypeWareClasses() {
      return httpService.get<apsViewModels.WareClassSelection[]>(Endpoints.DEFECT_TYPE_WARE_CLASS);
    }

    return {
      getDefectTypesAll: getDefectTypesAll,
      getDefectTypesAndClassifications: getDefectTypesAndClassifications,
      getDefectTypesAndClassificationsNoExclusion: getDefectTypesAndClassificationsNoExclusion,
      getDefectTypeDetails: getDefectTypeDetails,
      submitDefectType: submitDefectType,
      addDefectType: addDefectType,
      getDefectTypeWareClasses: getDefectTypeWareClasses
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/services/defects/defectType.service.ts